import { render, staticRenderFns } from "./ViewHome.vue?vue&type=template&id=4ed0b21e"
import script from "./ViewHome.vue?vue&type=script&lang=js"
export * from "./ViewHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports